const globalConfig = {
    'etc': {
        'baseUrl': 'https://terezvaros.hu',
        'youtubeUrl': 'https://www.youtube.com/channel/UCT7rOR20pRxsahFoehRc_dw',
    }
}

export default globalConfig;